import Vue from 'vue';
import Vuex from 'vuex';
import actions from './action';
import * as getters from './getters';
import state from './state';
import mutations from './mutations';
// import account from './modules/account';

Vue.use(Vuex);

Vue.config.warnExpressionErrors = true; // 数据为未出来时警告

export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations,
    strict: process.env.NODE_ENV !== 'production' // 严格模式
        // plugins:[]
});



// WEBPACK FOOTER //
// ./src/pages/admin/store/index.js